import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { aadharValidation } from "../validation/proof-details";

const AadharInput = ({
  name,
  title,
  type,
  value,
  error,
  handleChange,
  placeholder,
  className,page
}) => {
  const [aadhaar, setAadhaar] = useState("");
  
  useEffect(() => {
    if(value) {
      setAadhaar(value)
    }
  }, [value])

  const handleChangee = (e) => {
    const value = e.target.value;
    // const form = { aadhar: value };

    // const { errors, isValid } = aadharValidation(form);
   
    setAadhaar(value);
    handleChange(e);

    // setError(errors.aadhar);
  };

  return (
    <div className="mb-2 text-start">
      {title && (
        <label className="d-flex align-items-center fs-12 mb-2 form-label">
          <span className="required">{title}</span>
        </label>
      )}
      <input
        type={type}
        className={className ? className : "form-control  form-control-solid"}
        name={name}
        placeholder={placeholder}
        value={aadhaar}
        maxLength={12}
        onChange={(e) => {
          handleChangee(e);
        }}
      />
       <div style={page ? { height: "20px" } : {}}>
        <span className="fs-10 text-danger">{error}</span>
      </div>
     
    </div>
  );
};

AadharInput.prototype = {
  name: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  page: PropTypes.string
};
export default AadharInput;
